import { render, staticRenderFns } from "./BodyAnatomyEdit.vue?vue&type=template&id=5733d333&scoped=true&"
import script from "./BodyAnatomyEdit.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5733d333",
  null
  
)

export default component.exports